<template>
  <div class="openSansBold size8"
>
        <div class="text-left">
        <treeselect
          :options="options"
          :disable-branch-nodes=false
          :show-count=true
          class="opensansregularcase size10 mr-3"
          :placeholder="searchString"
          :label="searchString"
          :search-nested=true
          :flatten-search-results=false
          :limit="1"
          :disable-fuzzy-matching=false
          :searchable=true
          v-model="select" 
          :multiple=false />
        </div>
  </div>
</template>

<script>

// import axios from 'axios'
// import VectorSource from 'ol/source/Vector'
// import Feature from 'ol/Feature'
// import {Polygon} from 'ol/geom'
// import * as proj from "ol/proj"
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
// eslint-disable-next-line
// import Select2 from 'v-select2-component'
// import $ from 'jquery'

export default {
    icons: {
      iconfont: 'mdi', // default - only for display purposes
    },
    name: 'UnitSelector',
    components: {Treeselect},
    props: {show: Boolean, levelChanged: Boolean, countryChanged: Boolean, filterChg: Boolean},
    watch: {
      '$store.getters.TL': function() {
        console.log('*** TL Changed ***')
        let tl = this.$store.getters.TL
        this.searchString = 'Search for ' + tl
        this.populateTreeSelect()


        let params = this.$route.params
        let def_val = ''
        if (params.tu !== 'x') {
          def_val = params.tu
        }
        if (params.c !== 'x') {
          def_val = params.c
        }
        if (def_val !== '') {
          this.select = def_val
        } else {
          if (params.c === 'x' && params.tu === 'x') {
            this.select = null
          }
        }
        // this.select = null
      },
      '$store.getters.TU': function() {
        console.log(("**** TU Changed ****"))
        let tu = this.$store.getters.TU
        if (tu !== '' && tu != 'x') {
          this.select = tu
        } else {
          let params = this.$route.params
          if (params.c === 'x' && params.tu === 'x') {
            this.select = null
          }
        }
      },
      '$store.getters.CountryID': function() {
        console.log(("**** Country Changed ****"))
        let tu = this.$store.getters.CountryID
        if (tu !== '' && tu != 'x') {
          this.select = tu
        } else {
          this.select = null
        }
      },
      select: function (e) {
        if (!e) {
          e = 'x'
        }
        this.$root.$emit('change_tu', e)
      },
    },
    computed: {
      filter () {
        return this.caseSensitive
          ? (item, search, textKey) => item[textKey].indexOf(search) > -1
          : undefined
      }

    },

    methods: {
/*       myChangeEvent(val){
          console.log(val);
      },
      mySelectEvent({id, text}){
          console.log({id, text})
      }, */
      showIndicator: function () {
        this.overlay = true
      },
      loadCountriesByCode: function () {
        //console.log(this.$store.getters.countries)
        for (let c of this.$store.getters.countries) {
          this.countriesByCode[c.id] = c.name
        }
      },
      populateTreeSelect: function () {
        this.loadCountriesByCode()
        let tl = this.$store.getters.TL
        let tlToWalk = {}
        let tlTree = {}

        if (tl === "TL2") {
          tlToWalk = this.$store.getters.TL2
        }
        else if (tl === "TL3") {
          tlToWalk = this.$store.getters.TL3
        }
        else if (tl === "FUA") {
          tlToWalk = this.$store.getters.FUA
        }
        else if (tl === "EFUA") {
          tlToWalk = this.$store.getters.EFUA
        }
        else if (tl === "CY") {
          tlToWalk = this.$store.getters.CY
        }
        else
        {
          this.options = [];
          return;        
        }

        let code = ''
        for (let t of tlToWalk) {
          if (tl === "FUA" || tl === "CY" || tl === "EFUA") {
            code = t.id.toString()
            } 
          else {
            code = t.code.toString()
            }

          if (!tlTree[t.country]) {
            tlTree[t.country] = {}
          }

          tlTree[t.country][code] = t.name
        }

        let arrC = []
        for (let c in tlTree) {
          // console.log(c)
          arrC.push(c)
        }
        arrC.sort()
        let arr = []
        for (let m of arrC) {
          let childArr = []
          for (let tu in tlTree[m]) {
            childArr.push({id: tu, label: tlTree[m][tu]})
          }
          childArr.sort(this.compare)
          let objC = {id:m, label: m + ' - ' + this.countriesByCode[m], children:childArr} 
          arr.push(objC)
        }
        this.options = arr


        this.$forceUpdate()
      },
      },
      mounted () {
        this.populateTreeSelect()
        /*
        let params = this.$route.params
        let def_val = ''
        if (params.tu !== 'x') {
          def_val = params.tu
        }
        if (params.c !== 'x') {
          def_val = params.c
        }
        this.select = def_val
        */
      },

      data: () => ({
        select: null,
        countriesByCode: {},
        search: null,
        radioGroup: 1,
        searchString: 'Search for TL2' ,
        dialog: false,
        value: null,
        _data: null,
        myValue: '',
        _settings: null,
        country_id : '',
        options: [],
    })
}
</script>